import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import {
  Container,
  InstructionWrap,
  StepNumber,
} from "./Styled/ConnectStyled";
import { c } from '../../theme/colorUtils';
import CommonButton from "@/views/CommonComponent/CommonButton";
import PokoroPen from "@/common/Images/PokoroPen.png";
import PokoroInst from "@/common/Images/PokoroInst.png";
import { LocalStorageConnectSkip } from "../../stores/AuthStore";
import TitleBox from "../CommonComponent/TitleBox";
import { usePenStatus } from "../../nativebridge/PenStatus"; // 커스텀 훅을 import
import CommonLoading from "@/views/CommonComponent/CommonLoading";
import ComfirmDialog from "@/views/CommonComponent/ComfirmDialog";
import BaseDialog from "@/views/CommonComponent/BaseDialog";
import { Icon } from '@iconify/react';
import { IconButtonStyle } from "@/views/CommonComponent/Styled/CommonBackStyled";
import {
  connectPokoro,
  stopScan,
  disConnectPokoro,
  customSendToken,
  customSendSetting,
} from "../../nativebridge/JsToNative";
import BottomNavigation from "@/views/CommonComponent/BottomNavigation";
import {
  NativeToJsBridge,
  NativeToJsEventName,
  NativeToJsEventOnDeviceDisconnected,
  NativeToJsEventOnDeviceConnected,
  NativeToJsEventOnDeviceConnectFail,
} from "../../nativebridge/NativeToJs";

import { COMMON_UTIL } from "@/common/util/common.util";
import { inject, observer } from "mobx-react";
import { useToast } from "@/components/useToast";

const PendingProfileApplyToastKey = "_PENDING_PROFILE_APPLY_TOAST_";

const ConnectionComponent = (props) => {
  const { intl, languageStore, userStore, authStore } = props;
  const { showDeleteToast } = useToast();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const showElements = queryParams.get("showElements") === "true";
  const hideSkipButton = queryParams.get("hideSkipButton") === "true";

  const [reqSetLangAfterConnect, setLangAfterConnect] = React.useState(false);

  // 펜 연결 여부 확인
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  // 로딩바
  const [loading, setLoading] = React.useState(false);

  // 완료팝업
  const [goSetting, setGoSetting] = React.useState(false);
  // 건너뛰기 확인 모달
  const [skipConfirmOpen, setSkipConfirmOpen] = React.useState(false);

  // const [reqSetServer, setServer] = React.useState(false);

  let reqSetServer = false;
  useEffect(() => {
    console.log(globalPenStatus);
    console.log(`useEffect globalPenStatus${reqSetLangAfterConnect}`);
    if (reqSetLangAfterConnect) {
      setLangAfterConnect(false);
      const settingData = {
        messageType: "POKORO2_Settings",
        payload: {
          lang_system: globalPenStatus.deviceInfo.lang_system,
          lang_speaking: globalPenStatus.deviceInfo.lang_speaking,
          lang_listening_main: globalPenStatus.deviceInfo.lang_listening_main,
          lang_listening_sub: globalPenStatus.deviceInfo.lang_listening_sub,
        },
      };
      const lang_speaking = globalPenStatus.deviceInfo.lang_speaking;
      console.log(
        `customSendSetting globalPenStatus.deviceInfo.lang_system=${globalPenStatus.deviceInfo.lang_system},lang_speaking=${lang_speaking}`
      );

      customSendSetting(JSON.stringify(settingData));
    }
  }, [reqSetLangAfterConnect, globalPenStatus]);

  const handleBack = () => {
    history.push("/home");
  };

  const handlewifiConnect = () => {
    localStorage.setItem(LocalStorageConnectSkip, "true");
    history.push("/wifiConnect", { from: location.pathname });
    // history.push("/wifiConnect");
  };

  const handleClickSkip = () => {
    setSkipConfirmOpen(true);
  };

  const handleConfirmSkip = () => {
    setSkipConfirmOpen(false);
    localStorage.setItem(LocalStorageConnectSkip, "true");
    history.push("/home");
  };

  const handleCloseSkipConfirm = () => {
    setSkipConfirmOpen(false);
  };

  const onDeviceConnecting = () => {
    console.log("=== onDeviceConnecting");
    setLoading(true);
  };

  const onDeviceConnected = () => {
    // alert("=== onDeviceConnected");
    console.log("=== onDeviceConnected");
    setLoading(false);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: true, // isConnect 속성만 변경
    }));

    const countryCode = COMMON_UTIL.getCountryCodeFromLanguage(
      languageStore.language
    );

    if (globalPenStatus.deviceInfo.lang_system !== countryCode) {
      setLangAfterConnect(true);
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus,
        deviceInfo: {
          ...prevStatus.deviceInfo, // spread the previous deviceInfo object
          lang_system: countryCode, // update lang_main
        },
      }));
      // const settingData = {
      //   messageType: "POKORO2_Settings",
      //   payload: {
      //     lang_system: countryCode,
      //     lang_speaking: globalPenStatus.deviceInfo.lang_speaking,
      //     lang_listening_main: globalPenStatus.deviceInfo.lang_listening_main,
      //     lang_listening_sub: globalPenStatus.deviceInfo.lang_listening_sub,
      //   },
      // };
      // customSendSetting(JSON.stringify(settingData));
    }

    // setGoSetting(true);

    // showSuccessToast(
    //     <span style={{ whiteSpace: "pre-line" }}>
    //     {intl.formatMessage({ id: "connect_complete_toast" })} {/* 포코로 연결이 완료되었습니다. */}
    //   </span>
    // );

    // 다음 페이지 이동은 deviceId 수신(onSetDeviceId) 이후에 처리한다.
    // (userId + deviceId를 백엔드로 전송하고, user_device_profiles 상태를 확인한 뒤 분기)
  };

  const onDeviceDisConnected = () => {
    // alert("=== onDeviceDisConnected");
    console.log("=== onDeviceDisConnected");
    setLoading(false);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: false, // isConnect 속성만 변경
    }));
  };

  const onDeviceConnectFail = () => {
    // alert("=== onDeviceConnectFail");
    console.log("=== onDeviceConnectFail");
    setLoading(false);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      isConnect: false, // isConnect 속성만 변경
    }));
  };

  const onPokoroStatus = (jsonStr) => {
    // alert(`=== onPokoroStatus: ${jsonStr}`);
    setLoading(true);
    console.log(`=== onPokoroStatus: ${jsonStr.jsonStr}`);
    const status = JSON.parse(jsonStr.jsonStr);

    const serverList = JSON.parse(localStorage.getItem("_AGENT_SERVER_LIST_"));
    const Server = serverList.find(
      (server) => server.name === status.payload.serverInfo.name
    );
    const ServerUrl = Server ? Server.serverUrl : null;

    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      batteryPercentage: status.payload.batteryPercentage,
      storagePercentage: status.payload.storagePercentage,
      ConnectedAP1: status.payload.ConnectedAP1,
      ConnectedAP2: status.payload.ConnectedAP2,
      ConnectedAP3: status.payload.ConnectedAP3,
      deviceInfo: status.payload.deviceInfo,
      serverInfo: {
        ...prevStatus.serverInfo,
        name: status.payload.serverInfo.name,
        url: ServerUrl,
      },
      name: status.payload.deviceInfo.name,
    }));
    const settingData = {
      messageType: "POKORO2_Settings",
      payload: {
        server_name: status.payload.serverInfo.name,
        server_url: ServerUrl,
      },
    };
    reqSetServer = true;
    customSendSetting(JSON.stringify(settingData));
    
    // const authData = {
    //   messageType: "POKORO2_Auth",
    //   payload: {
    //     token: localStorage.getItem("_NDP_ACCESS_TOKEN_"), // 동적으로 주어진 토큰 값
    //     refreshToken: localStorage.getItem("_NDP_REFRESH_TOKEN_"), // 동적으로 주어진 리프레시 토큰 값
    //   },
    // };
    // customSendToken(JSON.stringify(authData));
  };

  const onCustomSendResult = (jsonStr) => {
    const result = JSON.parse(jsonStr.jsonStr);
    console.log(`onCustomSendResult=${result}`);
    if(reqSetServer){
      reqSetServer = false;
      const authData = {
        messageType: "POKORO2_Auth",
        payload: {
          token: localStorage.getItem("_NDP_ACCESS_TOKEN_"), // 동적으로 주어진 토큰 값
          refreshToken: localStorage.getItem("_NDP_REFRESH_TOKEN_"), // 동적으로 주어진 리프레시 토큰 값
        },
      };
      customSendToken(JSON.stringify(authData));
    }

  };

  // useEffect(() => {
  //   if (reqSetServer) {
  //     setServer(false);

  //   }
  // }, [reqSetServer]);

  useEffect(() => {
    console.log(
      "====_NDP_ACCESS_TOKEN_: " + localStorage.getItem("_NDP_ACCESS_TOKEN_")
    );
    console.log(
      "====_NDP_REFRESH_TOKEN_: " + localStorage.getItem("_NDP_REFRESH_TOKEN_")
    );
    console.log(
      "====_AGENT_SERVER_LIST_: " + localStorage.getItem("_AGENT_SERVER_LIST_")
    );

    connectPokoro();
    //NativeToJsEventOnDeviceConnecting
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnecting,
      async (event) => {
        onDeviceConnecting();
      }
    );
    //NativeToJsEventOnDeviceConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnected,
      async (event) => {
        onDeviceConnected();
      }
    );

    //NativeToJsEventOnDeviceDisConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        onDeviceDisConnected();
      }
    );

    //NativeToJsEventOnDeviceConnectFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnectFail,
      async (event) => {
        onDeviceConnectFail();
      }
    );

    //NativeToJsEventOnPokoroStatus
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onPokoroStatus,
      async (event) => {
        const jsonStr = event;
        onPokoroStatus(jsonStr);
      }
    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onCustomSendResult,
      async (event) => {
        const jsonStr = event;
        onCustomSendResult(jsonStr);
      }
    );

    NativeToJsBridge.instance.addEventListener(
        NativeToJsEventName.onSetDeviceId,
        async (event) => {
          const deviceId = event.deviceId;
          const userId = authStore.loginUser?.id;
          if (!userId) {
            console.warn("[POKOROConnect] onSetDeviceId ignored: missing userId");
            return;
          }

          const redirectUrl = "/wifiConnect?connectByPokoroSetting=true";

          try {
            const hasLinkedProfile = await userStore.getUserDeviceProfileExists(
              userId,
              deviceId
            );
            const hasUnlinkedProfile =
              await userStore.getUnlinkedDeviceProfileExists(userId);

            // 프로필이 없는 상태에서는 user_connected_devices에 저장하지 않는다.
            // 또한 프로필 설정 화면으로 이동해야 하는 케이스:
            // - (userId, deviceId) 프로필이 없고
            // - (userId, '') 프로필도 없을 때만
            if (!hasLinkedProfile && !hasUnlinkedProfile) {
              authStore.initProfileInfo();
              history.push("/signin/nickname", {
                notNewUser: true,
                redirectUrl,
                showBackButton: false
              });
              return;
            }

            // 프로필이 있을 때만 user_connected_devices upsert
            userStore.updateConnectedDevice(userId, deviceId, () => {
              userStore.getUserDeviceList(userId, true);
            });

            localStorage.setItem(LocalStorageConnectSkip, "true");
            history.push({
              pathname: "/wifiConnect",
              search: "?connectByPokoroSetting=true",
              state: { from: location.pathname },
            });
          } catch (e) {
            // 체크 실패 시에는 기존 흐름(와이파이 설정)으로 진행
            console.error(
              "[POKOROConnect] profile-existence check failed:",
              e
            );
            localStorage.setItem(LocalStorageConnectSkip, "true");
            history.push({
              pathname: "/wifiConnect",
              search: "?connectByPokoroSetting=true",
              state: { from: location.pathname },
            });
          }
        }
    );

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnecting
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceDisConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnectFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onPokoroStatus
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onCustomSendResult
      );
      NativeToJsBridge.instance.removeEventListener(
          NativeToJsEventName.onSetDeviceId
      );
      stopScan();
    };
  }, []);

  useEffect(() => {
    const shouldShowProfileApplyToast =
      localStorage.getItem(PendingProfileApplyToastKey) === "true";
    if (!shouldShowProfileApplyToast) {
      return;
    }
    localStorage.removeItem(PendingProfileApplyToastKey);
    showDeleteToast(
      intl.formatMessage(
        { id: "selectDeviceForProfile_applyCompleteToast" },
        { nickname: authStore.loginUser.nickname || "" }
      )
    );
  }, [authStore.loginUser.nickname, intl, showDeleteToast]);

  return (
    <Container>
      <>
        <TitleBox
          title={intl.formatMessage({ id: "connect_Title" })} /* 포코로 연결 */
          subtitle={intl.formatMessage({ id: "connect_Text" })} /* 연결할 포코로의 전원을 켜신 후 아래 가이드에 표시된 버튼을 눌러주세요 */
          onBack={handleBack}
        />

        <InstructionWrap px={3} py={4} justifyContent='flex-start'>
          <Stack gap={1} alignItems='flex-start'>
            <StepNumber>01</StepNumber>
            <Typography variant="body2" whiteSpace='normal'>
              {intl.formatMessage({ id: "connect_Note01" })} {/* 포코로의 전원 버튼을 꾹 눌러 주세요. */}
            </Typography>
          </Stack>
          <Stack gap={1} alignItems='flex-start' position='relative'>
            <StepNumber>02</StepNumber>
            <Stack flexDirection="row" gap={1} sx={{alignItems: 'flex-start', width: '100%' }}>
              <Typography variant="body2" whiteSpace='normal'>
                {intl.formatMessage({ id: "connect_Note02" })} {/* 볼륨 (+) (-) 버튼을 동시에 꾹 눌러주세요. */}
              </Typography>
              <img src={PokoroInst} alt="Device" style={{ flexShrink: 0, maxWidth: '50px' }}/>
            </Stack>
          </Stack>
          <Stack gap={1} alignItems='flex-start'>
            <StepNumber>03</StepNumber>
            <Typography variant="body2" whiteSpace='normal'>
              {intl.formatMessage({ id: "connect_Note03" })} {/* "앱에서 와이파이를 연결해주세요" 소리가 들리면 APP과 연결될 때까지 잠시만 기다려 주세요. */}
            </Typography>
          </Stack>
        </InstructionWrap>
        
        <Box p={3}>
          <CommonButton
            text={intl.formatMessage({ id: "connect_skip_confirm_skip" })} /* 건너뛰기 */
            background={c.bg}
            border={c.grayHard}
            color={c.text02}
            onClick={handleClickSkip}
          />
        </Box>

        <BaseDialog
          open={skipConfirmOpen}
          title={intl.formatMessage({ id: "connect_skip_confirm_title" })} /* 기기 연결을 건너뛰시겠습니까? */
          content={intl.formatMessage({ id: "connect_skip_confirm_text" })} /* 기기 연결 후 포코로와의 대화 및 서비스 이용이 가능합니다. */
          actionType="double"
          leftButtonText={intl.formatMessage({ id: "connect_skip_confirm_skip" })} /* 건너뛰기 */
          rightButtonText={intl.formatMessage({ id: "connect_skip_confirm_connect" })} /* 기기 연결하기 */
          onLeftClick={handleConfirmSkip}
          onRightClick={handleCloseSkipConfirm}
        />
        <ComfirmDialog
          open={goSetting}
          title={intl.formatMessage({ id: "connect_complete_dialog_Title" })} /* 포코로 연결 완료 */
          contents={<pre>{intl.formatMessage({ id: "connect_complete_dialog_text" })}</pre>} /* 포코로 연결이 완료되었습니다. Wi-Fi를 설정해주세요. */
          buttonText={intl.formatMessage({ id: "dialog_confirmButton" })} /* 확인 */
          onClick={handlewifiConnect}
        />
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 9999,
            }}
          >
            <CommonLoading
              text={intl.formatMessage({ id: "pokoro_connecting" })}
            />
          </div>
        )}
      </>
    </Container>
  );
};

export default injectIntl(
  inject("languageStore", "userStore", "authStore")(observer(ConnectionComponent))
);
